import { KoobInputDate, KoobInputNumber } from '@koob/ui';
import { ChildAgeModeEnum } from './types';
import type { ChildEntry, FolderChildrenAgesFieldProps } from './types';
import { parseDateOnly } from '@koob/dates';
import { CHILD_MAX_AGE } from './folderFormState';

export type { FolderChildrenAgesFieldProps };

export function FolderChildrenAgesField({
  entries,
  onBirthdateChange,
  onAgeChange,
  onModeChange,
  t,
}: FolderChildrenAgesFieldProps) {
  if (entries.length === 0) return null;

  return (
    <div className="rounded-xl border border-gray-200 bg-gray-50 p-5">
      <span className="block text-xs font-semibold uppercase tracking-wide text-gray-400">
        {t('travellers.birthdates')}
      </span>
      <p className="mt-1 text-sm text-gray-400">
        {t('travellers.birthdatesHint')}
      </p>

      <div className="mt-4 flex flex-col gap-3">
        {entries.map((child, i) => {
          // A child whose exact birthdate is unknown is captured by age: the
          // birthdate is then estimated, which the traveller details flag.
          const isAgeMode = child.mode === ChildAgeModeEnum.AGE;

          return (
            <div key={i} className="flex flex-wrap items-center gap-3">
              <span className="w-20 shrink-0 text-sm font-medium text-gray-700">
                {t('travellers.child', {
                  index: i + 1,
                })}
              </span>

              <div className="w-52">
                {isAgeMode ? (
                  <KoobInputNumber
                    integer
                    min={0}
                    max={CHILD_MAX_AGE}
                    value={child.age}
                    onValueChange={(age) => onAgeChange(i, age)}
                    placeholder={t('travellers.agePlaceholder')}
                  />
                ) : (
                  <KoobInputDate
                    value={parseDateOnly(child.birthdate)}
                    onChange={(date) => onBirthdateChange(i, date)}
                    maxDate={new Date()}
                    block
                  />
                )}
              </div>

              <button
                type="button"
                className="cursor-pointer border-none bg-transparent p-0 text-sm font-medium text-brand hover:underline"
                onClick={() =>
                  onModeChange(
                    i,
                    isAgeMode ? ChildAgeModeEnum.DATE : ChildAgeModeEnum.AGE,
                  )
                }
              >
                {isAgeMode ? t('useExactBirthdate') : t('onlyKnowAge')}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
